import { DSModal } from "@components/design-system/organisms";

const DeleteTemplateGroupModal = ({
  isOpen,
  onClose,
  onConfirm,
  groupName,
  deleting = false,
}) => (
  <DSModal
    isOpen={isOpen}
    onClose={onClose}
    title="Delete Template Group"
    actions={[
      { label: "Cancel", variant: "cancel", onClick: onClose },
      {
        label: deleting ? "Deleting..." : "Delete",
        variant: "primary",
        onClick: onConfirm,
        disabled: deleting,
        dataTestId: "confirm-delete-template-group-button",
      },
    ]}
    dataTestId="delete-template-group-modal"
  >
    <p>
      Are you sure you want to delete <b>{groupName}</b>? This will
      not delete the templates themselves.
    </p>
    <p>
      <b>This action cannot be undone.</b>
    </p>
  </DSModal>
);

export default DeleteTemplateGroupModal;
